const t = {};
export {
  t as default
};
//# sourceMappingURL=validation.json.js.map
